import { Component, OnDestroy, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { Observable, Subscription } from 'rxjs';

import { AppState } from 'src/app/state';
import { Template } from 'src/app/models/template';
import { Section } from 'src/app/models/section';
import { selectSelectedTemplate } from 'src/app/dashboard/state/templates/templates.selectors';
import {
  selectIsLoadingSections,
  selectSectionsLoaded,
  selectSorteredSections,
} from 'src/app/dashboard/state/sections/sections.selectors';
import { openDashboardConfirmationDialog } from 'src/app/dashboard/state/dashboard.actions';
import {
  deleteSection,
  getSection,
  saveSectionsSortingOrder,
  setSelectedSection,
} from 'src/app/dashboard/state/sections/sections.actions';
import { SectionDialogComponent } from '../../../components/section-dialog/section-dialog.component';
import { getSubsections, setSelectedSubsection } from 'src/app/dashboard/state/subsections/subsections.actions';

@Component({
  selector: 'dashboard-sections',
  templateUrl: './sections.component.html',
  styleUrls: ['./sections.component.scss'],
})
export class SectionsComponent implements OnInit, OnDestroy {
  loadingSections$: Observable<boolean>;
  sectionsLoaded$: Observable<boolean>;

  selectedTemplate: Template;
  sections: Section[];

  currentDropEvent: CdkDragDrop<Section[]>;
  sectionToDrop: Section = null;

  private subscriptions = new Subscription();

  constructor(private store: Store<AppState>, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadingSections$ = this.store.select(selectIsLoadingSections);
    this.sectionsLoaded$ = this.store.select(selectSectionsLoaded);
    this.subscriptions.add(
      this.store.select(selectSelectedTemplate).subscribe((template) => (this.selectedTemplate = template))
    ),
      this.subscriptions.add(
        this.store.select(selectSorteredSections).subscribe((sections) => (this.sections = sections))
      );
  }

  dropSection(event): void {
    this.currentDropEvent = event;
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.saveSectionsSortingOrder(event.container.data);
  }

  saveSectionsSortingOrder(sectionsArray: Section[]) {
    const newSectionsSortingOrder = this.getSectionsSortOrderArray(sectionsArray);
    this.store.dispatch(
      saveSectionsSortingOrder({
        templateId: this.selectedTemplate?.id,
        sortingOrder: newSectionsSortingOrder,
      })
    );
  }

  getSectionsSortOrderArray(sections: Section[]): number[] {
    return sections?.map((section) => section.id);
  }

  openCreateSectionDialog() {
    this.dialog.open(SectionDialogComponent, { width: '100%', height: '95%' });
    this.store.dispatch(setSelectedSection({ selectedSection: null }));
    this.store.dispatch(getSubsections({ subsections: [] }));
    this.store.dispatch(setSelectedSubsection({ selectedSubsection: null }));
  }

  openUpdateSectionDialog(section: Section) {
    this.dialog.open(SectionDialogComponent, { width: '100%', height: '95%' });
    this.store.dispatch(getSection({ sectionId: section.id }));
    this.store.dispatch(setSelectedSubsection({ selectedSubsection: null }));
  }

  openDeleteSectionDialog(section: Section) {
    this.store.dispatch(
      openDashboardConfirmationDialog({
        dialogData: {
          title: 'Are you sure you want to delete this section?',
          onConfirm: deleteSection({ section }),
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
